import styled, { css } from 'styled-components';

// Import styles utilities
import { media, flex } from 'components/styles';

// Import components
import { Heading, Button } from 'components/elements';

export const Content = styled.div`
	${flex({ fd: 'column', jc: 'space-between' })}
	width: 100%;
	aspect-ratio: 16 / 9;
	margin: 1rem auto;
	background: ${({ image }) =>
		image
			? `linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.55)),
				url(${image})`
			: 'none'};
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	border-radius: 0.5rem;
	padding: 3rem 2rem;
`;

export const HeadingThirdStyled = styled(Heading.Third)`
	text-align: center;
	font-weight: ${({ theme }) => theme.font.normal};
	margin-bottom: 0.5rem;
`;

export const Paragraph = styled.p`
	font-size: 1rem;
	color: ${({ theme }) => theme.white};
	opacity: 0.7;
	text-align: center;
	padding: 0 0.5rem;
	${media.min.medium(css`
		font-size: 1.2rem;
		padding: 0 1rem;
	`)}
	${media.min.max(css`
		font-size: 1.4rem;
		padding: 0 2rem;
	`)}
`;

export const LinkStyled = styled(Button)`
	${flex()}
	text-align: center;
	border: 1px solid rgba(255, 255, 255, 0.22);
	box-shadow: none;
	margin-top: 1rem;

	&:hover {
		color: ${({ theme }) => theme.white};
	}

	&:before {
		background: #00000024;
	}
`;

export const Wrapper = styled.div`
	display: ${({ isPacketsAvailable }) => (isPacketsAvailable ? 'block' : 'flex')}
	min-height: 20rem;
	align-items: center;
	justify-content: center;
`;

export const HeadingSecondStyled = styled(Heading.Second)`
	text-align: center;
	font-weight: ${({ theme }) => theme.font.normal};
	margin-bottom: 4rem;
	width: 30rem;
`;
